import { Dispatch } from "redux";
import { findPatientSync, patientSyncCreate } from "api/patient-sync.api";
import {
  PatientSync,
  SyncServiceType,
  SyncState,
} from "model/patient-sync.model";
import {
  LOAD_PATIENTSYNC_ERROR,
  LOAD_PATIENTSYNC_START,
  LOAD_PATIENTSYNC_SUCCESS,
  PatientSyncAction,
  SET_PATIENTSYNC,
  SET_PATIENTSYNC_ERROR,
  SET_PATIENTSYNC_SUCCESS,
} from "store/types/patient-sync.types";

/** ---- ACTIONS ---- */

export const loadPatientSync = (userId: number, patientId: number) => {
  return async (dispatch: Dispatch<PatientSyncAction>) => {
    try {
      dispatchLoadPatientSyncStart()(dispatch);
      const patientSyncs = await findPatientSync(userId, patientId);
      dispatchLoadPatientSyncSuccess(patientSyncs)(dispatch);
    } catch (e) {
      dispatchLoadPatientSyncError()(dispatch);
    }
  };
};

export const createPatientSync = (
  userId: number,
  patientId: number,
  syncServiceType: SyncServiceType
) => {
  return async (dispatch: Dispatch<PatientSyncAction>) => {
    try {
      dispatchCreatePatientSync(syncServiceType)(dispatch);
      const patientSync = await patientSyncCreate(
        userId,
        patientId,
        syncServiceType
      );
      dispatchCreatePatientSyncSuccess(patientSync)(dispatch);
    } catch (e) {
      dispatchCreatePatientSyncError()(dispatch);
    }
  };
};

/** ---- DISPATCHERS ---- */
const dispatchLoadPatientSyncStart = () => {
  return (dispatch: Dispatch<PatientSyncAction>) => {
    dispatch({
      type: LOAD_PATIENTSYNC_START,
    });
  };
};

const dispatchLoadPatientSyncSuccess = (response: PatientSync[]) => {
  return (dispatch: Dispatch<PatientSyncAction>) => {
    dispatch({
      type: LOAD_PATIENTSYNC_SUCCESS,
      payload: response,
    });
  };
};

const dispatchLoadPatientSyncError = () => {
  return (dispatch: Dispatch<PatientSyncAction>) => {
    dispatch({
      type: LOAD_PATIENTSYNC_ERROR,
    });
  };
};

const dispatchCreatePatientSync = (serviceType: SyncServiceType) => {
  return (dispatch: Dispatch<PatientSyncAction>) => {
    dispatch({
      type: SET_PATIENTSYNC,
      payload: {
        serviceType: serviceType,
        syncState: SyncState.FINISHED,
      },
    });
  };
};

const dispatchCreatePatientSyncSuccess = (response: PatientSync) => {
  return (dispatch: Dispatch<PatientSyncAction>) => {
    dispatch({
      type: SET_PATIENTSYNC_SUCCESS,
      payload: response,
    });
  };
};

const dispatchCreatePatientSyncError = () => {
  return (dispatch: Dispatch<PatientSyncAction>) => {
    dispatch({
      type: SET_PATIENTSYNC_ERROR,
    });
  };
};
